const getters = {
  CONTENT_TYPE: state => state.app.CONTENT_TYPE,
  PAGE: state => state.app.PAGE,
  nodeCode: state => state.app.nodeCode,
  wxAppId: state => state.app.wxAppId,
  authType: state => state.app.authType,
  clientId: state => state.app.clientId,
  clientSecret: state => state.app.clientSecret,
  shareUrl: state => state.app.shareUrl,
  DOWNLOAD_URL: state => state.app.DOWNLOAD_URL,
  token: state => state.app.token,
  userInfo: state => state.app.userInfo,
}
export default getters
